import { AnimatePresence } from 'motion/react'
import { HTMLAttributes } from 'react'
import { Outlet } from 'react-router-dom'

import { cn } from '@/theme/utils'

export default function MainLayout({
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cn(
        rest.className,
        'isolate h-[100dvh] w-[100dvw] overflow-x-hidden',
      )}
    >
      <div className='absolute inset-0 z-20'>
        <AnimatePresence>
          <Outlet />
        </AnimatePresence>
      </div>
    </div>
  )
}
